import { getApiEndpoint } from '../config/api';
import { fetchWithAuth } from '../utils/api';

export async function getAllProperties() {
  const res = await fetchWithAuth(getApiEndpoint('/api/properties'));
  if (!res) return null;
  if (!res.ok) throw new Error('Failed to fetch properties');
  return res.json();
}

export async function listOnboardingApiKeys() {
  const res = await fetchWithAuth(getApiEndpoint('/api/onboarding/api-keys'));
  if (!res) return null;
  if (!res.ok) throw new Error('Failed to list API keys');
  return res.json();
}

export async function createOnboardingApiKey(payload) {
  const res = await fetchWithAuth(getApiEndpoint('/api/onboarding/api-keys'), {
    method: 'POST',
    body: JSON.stringify(payload)
  });
  if (!res) return null;
  if (!res.ok) {
    let message = 'Failed to create API key';
    try {
      const body = await res.json();
      if (body?.error) message = `${message}: ${body.error}`;
      if (body?.message) message = `${message}: ${body.message}`;
    } catch (_) {}
    throw new Error(message);
  }
  return res.json();
}

export async function listUsers(search = '') {
  const q = search ? `?search=${encodeURIComponent(search)}` : '';
  const res = await fetchWithAuth(getApiEndpoint(`/api/users${q}`));
  if (!res) return null;
  if (!res.ok) {
    let message = 'Failed to list users';
    try {
      const body = await res.json();
      if (body?.error) message = `${message}: ${body.error}`;
      if (body?.message) message = `${message}: ${body.message}`;
    } catch (_) {}
    throw new Error(message);
  }
  return res.json();
}

export async function listPropertyAccess(propertyId) {
  const res = await fetchWithAuth(getApiEndpoint(`/api/properties/${propertyId}/access`));
  if (!res) return null;
  if (!res.ok) throw new Error('Failed to list property access');
  return res.json();
}

export async function assignPropertyAccess(propertyId, payload) {
  const res = await fetchWithAuth(getApiEndpoint(`/api/properties/${propertyId}/access`), {
    method: 'POST',
    body: JSON.stringify(payload)
  });
  if (!res) return null;
  if (!res.ok) {
    let message = 'Failed to assign access';
    try {
      const body = await res.json();
      if (body?.error) message = `${message}: ${body.error}`;
      if (body?.message) message = `${message}: ${body.message}`;
    } catch (_) {}
    throw new Error(message);
  }
  return res.json();
}

export async function removePropertyAccess(propertyId, userRoleId) {
  const res = await fetchWithAuth(getApiEndpoint(`/api/properties/${propertyId}/access/${userRoleId}`), {
    method: 'DELETE'
  });
  if (!res) return null;
  if (!res.ok) throw new Error('Failed to remove access');
  return res.json();
}

export async function getImportResults(params = {}) {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.status) queryParams.append('status', params.status);
  if (params.search) queryParams.append('search', params.search);

  const url = getApiEndpoint(`/api/onboarding/import-results${queryParams.toString() ? `?${queryParams.toString()}` : ''}`);
  const res = await fetchWithAuth(url);
  if (!res) return null;
  if (!res.ok) {
    let message = 'Failed to load import results';
    try {
      const body = await res.json();
      if (body?.error) message = `${message}: ${body.error}`;
      if (body?.message) message = `${message}: ${body.message}`;
    } catch (_) {}
    throw new Error(message);
  }
  return res.json();
}

export async function getImportResultDetails(id) {
  const res = await fetchWithAuth(getApiEndpoint(`/api/onboarding/import-results/${id}`));
  if (!res) return null;
  if (!res.ok) {
    let message = 'Failed to load import result details';
    try {
      const body = await res.json();
      if (body?.error) message = `${message}: ${body.error}`;
      if (body?.message) message = `${message}: ${body.message}`;
    } catch (_) {}
    throw new Error(message);
  }
  return res.json();
}

export async function getAuditTrail(filters = {}) {
  const params = new URLSearchParams();
  if (filters.propertyId) params.append('propertyId', filters.propertyId);
  if (filters.userId) params.append('userId', filters.userId);
  if (filters.fromDate) params.append('fromDate', filters.fromDate);
  if (filters.toDate) params.append('toDate', filters.toDate);
  if (filters.actionType) params.append('actionType', filters.actionType);

  const res = await fetchWithAuth(getApiEndpoint(`/api/properties/audit-trail?${params.toString()}`));
  if (!res) return null;
  if (!res.ok) {
    let message = 'Failed to load audit trail';
    try {
      const body = await res.json();
      if (body?.error) message = `${message}: ${body.error}`;
    } catch (_) {}
    throw new Error(message);
  }
  return res.json();
}


